import { ApolloClient, HttpLink, InMemoryCache, concat } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { getJwt } from './authentication';
import { notifyGraphqlError } from './bugsnag';

const errorLink = onError(notifyGraphqlError);

const httpLink = new HttpLink({
  // Default uri to /graphql if not testing
  uri: `${
    window.location.origin.substr(0, 17) === 'https://localhost'
      ? `https://${process.env.REACT_APP_ENV || 'dev'}-store.calix.com`
      : ''
  }/graphql`,
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'x-api-key': process.env.REACT_APP_GRAPHQL_API_KEY,
      authorization: `Bearer ${getJwt()}`,
    },
  };
});

export const client = new ApolloClient({
  link: concat(errorLink, authLink.concat(httpLink)),
  cache: new InMemoryCache({
    typePolicies: {
      Account: {
        keyFields: ['accountId'],
      },
      RmaCase: {
        keyFields: ['caseNumber'],
      },
    },
  }),
});
